import copy from "fast-copy";

export default function defensiveCopy<T>(obj: T): T {
  if (!obj) {
    return obj;
  }

  return copy(obj);
}
